import classNames from 'classnames'
import { Check } from 'lucide-react'
import React, { ReactNode } from 'react'

import { FlexCol } from '../../../../common/frontend/components/flex-col/flex-col.js'
import { FlexRow } from '../../../../common/frontend/components/flex-row/flex-row.js'

export interface CheckboxProps {
    label: ReactNode
    className?: string
    isChecked: boolean
    onChange: (isChecked: boolean) => void
    isDisabled?: boolean
    attrDisabled?: boolean
    note?: React.ReactNode
    size: 'large' | 'small'
}

export const Checkbox = (props: CheckboxProps) => {
    return (
        <FlexCol
            className={classNames('checkbox', `checkbox--${props.size}`, props.className)}
            gap={0.5}
        >
            <label className={classNames('checkbox__container')}>
                <input
                    type="checkbox"
                    className="checkbox__input"
                    checked={props.isChecked}
                    disabled={props.isDisabled || props.attrDisabled}
                    onChange={(event) => {
                        props.onChange(event.currentTarget.checked)
                    }}
                />
                <FlexRow
                    className={classNames('checkbox__indicator')}
                    vertical="center"
                    horizontal="center"
                >
                    <Check className={classNames('checkbox__icon')} />
                </FlexRow>
                <div className={classNames('checkbox__label')}>{props.label}</div>
            </label>
            {props.note && props.note}
        </FlexCol>
    )
}
